<script lang="ts" setup>
import { PagesPrefixEnum } from '~/enums/PagesPrefixEnum'
import { Routes } from '~/enums/Routes'
import { useStoreConfig } from '~/store/storeConfig'

const props = defineProps<{
  isFullWidth?: boolean
}>()

const { isAlt } = useTheme()
const storeConfig = useStoreConfig()
const currentRoute = useRoute().name

const isProPage = computed(() => {
  const matched = [Routes.Account.SitePro, Routes.Account.SiteProDelivery, Routes.Account.SiteProPaymentId].findIndex(
    (route) => currentRoute === `${PagesPrefixEnum}${route}`
  )

  return matched !== -1
})

const handleError = (error: any) => {
  error.value = null
}

const logError = (error: any) => {
  console.error(error)
}
</script>

<template>
  <div>
    <slot name="app-before" />
    <div id="app-before"></div>
    <div class="flex flex-col min-h-screen">
      <slot name="header">
        <LayoutHeader />
      </slot>
      <NuxtErrorBoundary @error="logError">
        <main
          :key="storeConfig.getIsMobile.valueOf.toString()"
          class="flex-1 w-full flex flex-col mx-auto"
          :class="{
            'max-w-xlg lg:px-[15px]': !props.isFullWidth,
            mobile: storeConfig.getIsMobile || storeConfig.isTablet,
          }">
          <div class="relative flex-1 flex flex-col w-full h-full min-h-[80vh]">
            <slot />
          </div>
        </main>
        <template #error="{ error }">
          <div class="flex items-center justify-center flex-col gap-[30px] p-4 min-h-[50rem]">
            <h5>
              There was an error
              <i class="far fa-face-sad-cry bg-yellow rounded-full"></i>
            </h5>
            <pre> {{ error }} </pre>
            <Button @click="handleError(error)" v-text="'Clear the error'" />
          </div>
        </template>
      </NuxtErrorBoundary>
      <slot name="footer">
        <LazyFooterJav v-if="isAlt" :is-pro="isProPage" />
        <LazyFooter v-else />
      </slot>
    </div>
    <slot name="app-after" />
    <div id="app-after"></div>
  </div>
</template>

<style lang="postcss" scoped>
main {
  &.mobile {
    margin-top: theme('vars.mobileHeaderHeight');
  }
}
</style>
